import React, { useState } from 'react';
import { login, forgotPassword } from '../services/api';

function Login({ onLogin }) {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [vista, setVista] = useState('login'); // login | forgot | enviado
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotError, setForgotError] = useState('');

  const handleSubmit = async () => {
    if (!form.email || !form.password) { setError('Completa todos los campos'); return; }
    setLoading(true); setError('');
    try {
      const res = await login(form);
      localStorage.setItem('token', res.data.token);
      onLogin(res.data.usuario);
    } catch (err) {
      setError(err.response?.data?.message || 'Credenciales incorrectas. Verifica tu email y contraseña.');
    } finally { setLoading(false); }
  };

  const handleForgot = async () => {
    if (!forgotEmail) { setForgotError('Ingresa tu correo'); return; }
    setForgotLoading(true); setForgotError('');
    try {
      await forgotPassword({ email: forgotEmail, frontendUrl: window.location.origin });
      setVista('enviado');
    } catch {
      setForgotError('Error al enviar el correo. Intenta de nuevo.');
    } finally { setForgotLoading(false); }
  };

  if (vista === 'forgot') {
    return (
      <div style={{ minHeight: '100vh', background: '#0d2461', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ background: 'white', borderRadius: 16, padding: '48px 40px', width: '100%', maxWidth: 420, boxShadow: '0 25px 50px rgba(0,0,0,0.3)' }}>
          <div style={{ textAlign: 'center', marginBottom: 28 }}>
            <div style={{ width: 64, height: 64, background: '#0d2461', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>🔑</div>
            <h1 style={{ fontSize: 20, fontWeight: 700, color: '#0d2461', margin: 0 }}>Recuperar Contraseña</h1>
            <p style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>Te enviaremos un enlace a tu correo</p>
          </div>

          {forgotError && (
            <div style={{ background: '#fee2e2', color: '#cc0000', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16, border: '1px solid #fca5a5' }}>
              ⚠️ {forgotError}
            </div>
          )}

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#334155', marginBottom: 6 }}>Email</label>
            <input
              type="email" value={forgotEmail}
              onChange={e => setForgotEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleForgot()}
              style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
              placeholder="usuario@embarque.com"
            />
          </div>

          <button onClick={handleForgot} disabled={forgotLoading}
            style={{ width: '100%', padding: 13, background: forgotLoading ? '#94a3b8' : '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: forgotLoading ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
            {forgotLoading ? 'Enviando...' : 'Enviar Enlace de Recuperación'}
          </button>

          <p onClick={() => { setVista('login'); setForgotError(''); }}
            style={{ textAlign: 'center', fontSize: 13, color: '#0d2461', marginTop: 20, cursor: 'pointer', fontWeight: 600 }}>
            ← Volver al inicio de sesión
          </p>
        </div>
      </div>
    );
  }

  if (vista === 'enviado') {
    return (
      <div style={{ minHeight: '100vh', background: '#0d2461', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ background: 'white', borderRadius: 16, padding: '48px 40px', width: '100%', maxWidth: 420, boxShadow: '0 25px 50px rgba(0,0,0,0.3)', textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, background: '#dcfce7', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>✅</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: '#0d2461', margin: 0 }}>Correo Enviado</h1>
          <p style={{ fontSize: 14, color: '#64748b', marginTop: 12, lineHeight: 1.5 }}>
            Si el correo <strong>{forgotEmail}</strong> está registrado, recibirás un enlace para restablecer tu contraseña. Revisa tu bandeja de entrada (y spam).
          </p>
          <button onClick={() => { setVista('login'); setForgotEmail(''); }}
            style={{ width: '100%', padding: 13, background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', marginTop: 20 }}>
            Volver al inicio de sesión
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0d2461', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 16, padding: '48px 40px', width: '100%', maxWidth: 420, boxShadow: '0 25px 50px rgba(0,0,0,0.3)' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 64, height: 64, background: '#0d2461', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>🚢</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#0d2461', margin: 0 }}>Embarque Oriental</h1>
          <p style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>Sistema de Gestión de Envíos</p>
        </div>

        {/* Error */}
        {error && (
          <div style={{ background: '#fee2e2', color: '#cc0000', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16, border: '1px solid #fca5a5' }}>
            ⚠️ {error}
          </div>
        )}

        {/* Form */}
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#334155', marginBottom: 6 }}>Email</label>
          <input
            type="email" value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
            placeholder="usuario@embarque.com"
          />
        </div>

        <div style={{ marginBottom: 10 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#334155', marginBottom: 6 }}>Contraseña</label>
          <input
            type="password" value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
            placeholder="••••••••"
          />
        </div>

        <p onClick={() => setVista('forgot')}
          style={{ textAlign: 'right', fontSize: 13, color: '#0d2461', marginBottom: 24, cursor: 'pointer', fontWeight: 600 }}>
          ¿Olvidaste tu contraseña?
        </p>

        <button onClick={handleSubmit} disabled={loading}
          style={{ width: '100%', padding: 13, background: loading ? '#94a3b8' : '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
          {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
        </button>
      </div>
    </div>
  );
}

export default Login;